export const isFlagOn = (value: unknown): boolean =>
    value === true ||
    value === 1 ||
    value === "true" ||
    value === "1";
